import { render, staticRenderFns } from "./npl-xfby.vue?vue&type=template&id=2df2cef4&scoped=true"
import script from "./npl-xfby.vue?vue&type=script&lang=js"
export * from "./npl-xfby.vue?vue&type=script&lang=js"
import style0 from "./npl-xfby.vue?vue&type=style&index=0&id=2df2cef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df2cef4",
  null
  
)

export default component.exports